/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 运维审核类型
 */
// let EnumMalfunctionAuditStatus = {
//     WaitSubmit: 					new EnumItem('待提交', 3),
//     NotSubmit: 						new EnumItem('不提交', 4),
// 	Audited: 						new EnumItem('审核通过', 1),
// 	Reject: 						new EnumItem('审核不通过', 2),
//     UnAudit: 						new EnumItem('待审核', 0),
// 	...enumMixn
// }
let EnumMalfunctionAuditStatus = {
    待提交: 					new EnumItem('待提交', 3),
    不提交: 						new EnumItem('不提交', 4),
	审核通过: 						new EnumItem('审核通过', 1),
	审核不通过: 						new EnumItem('审核不通过', 2),
    待审核: 						new EnumItem('待审核', 0),
	...enumMixn
}
export default EnumMalfunctionAuditStatus
